module.exports = __webpack_public_path__ + "img/sculpt5_thumb.50fae8e2.jpg";